import React from 'react';

interface TitleBadgeProps {
  title: {
    titleId: number;
    name: string;
    icon: string;
    rarity: 'common' | 'rare' | 'epic' | 'legendary';
  } | null;
  size?: 'small' | 'medium' | 'large';
  showTooltip?: boolean;
}

export const TitleBadge: React.FC<TitleBadgeProps> = ({
  title,
  size = 'small',
  showTooltip = true,
}) => {
  if (!title) {
    return null;
  }

  // 크기 설정
  const dimensions =
    size === 'large'
      ? { width: 32, height: 32, fontSize: 16 }
      : size === 'medium'
      ? { width: 24, height: 24, fontSize: 12 }
      : { width: 20, height: 20, fontSize: 10 };

  // 희귀도별 스타일
  const rarityStyles = {
    common: {
      bg: 'linear-gradient(135deg, #6b7280, #4b5563)',
      shadow: '0 2px 8px rgba(107, 114, 128, 0.3)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    rare: {
      bg: 'linear-gradient(135deg, #4cc9f0, #3b9bc2)',
      shadow: '0 3px 10px rgba(76, 201, 240, 0.4)',
      border: '1px solid rgba(76, 201, 240, 0.3)',
    },
    epic: {
      bg: 'linear-gradient(135deg, #9d4edd, #7b2cbf)',
      shadow: '0 4px 12px rgba(157, 78, 221, 0.5)',
      border: '1px solid rgba(157, 78, 221, 0.4)',
    },
    legendary: {
      bg: 'linear-gradient(135deg, #ff6b00, #ff8c00)',
      shadow: '0 5px 15px rgba(255, 107, 0, 0.6)',
      border: '2px solid rgba(255, 200, 0, 0.5)',
      animation: 'legendary-glow 2s ease-in-out infinite alternate',
    },
  };

  const style = rarityStyles[title.rarity] || rarityStyles.common;

  return (
    <div
      className={`title-badge-container rarity-${title.rarity}`}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      title={showTooltip ? title.name : undefined}
    >
      <div
        className={`title-badge rarity-${title.rarity}`}
        style={{
          position: 'relative',
          width: `${dimensions.width}px`,
          height: `${dimensions.height}px`,
          background: style.bg,
          borderRadius: '50%',
          boxShadow: `${style.shadow}, inset 0 2px 4px rgba(255, 255, 255, 0.3), inset 0 -2px 4px rgba(0, 0, 0, 0.3)`,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: style.border,
          fontSize: `${dimensions.fontSize}px`,
          fontWeight: 'bold',
          color: 'white',
          textShadow: '1px 1px 2px rgba(0, 0, 0, 0.8)',
          zIndex: 2,
          textAlign: 'center',
          lineHeight: 1,
          cursor: showTooltip ? 'help' : 'default',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'scale(1.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'scale(1)';
        }}
      >
        {title.icon || '👑'}
      </div>
      {title.rarity === 'legendary' && (
        <style>
          {`
            @keyframes legendary-glow {
              0% {
                box-shadow: 0 5px 15px rgba(255, 107, 0, 0.6), 0 0 10px rgba(255, 200, 0, 0.4);
              }
              100% {
                box-shadow: 0 5px 20px rgba(255, 107, 0, 0.8), 0 0 20px rgba(255, 200, 0, 0.6);
              }
            }
          `}
        </style>
      )}
    </div>
  );
};




